// extracted by mini-css-extract-plugin
export var active = "_2h-b";
export var activeIndicator = "_2h-6";
export var animate = "_2h-a";
export var disabled = "_2h-c";
export var flat = "_2h-1";
export var fullWidth = "_2h-3";
export var lg = "_2h-9";
export var md = "_2h-8";
export var redoButtonTabGroup = "_2h-0";
export var sm = "_2h-7";
export var tabButton = "_2h-4";
export var tabButtonsContainer = "_2h-2";
export var xs = "_2h-5";